var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('final-recon-form',{attrs:{"create":_vm.create,"view":_vm.view,"change":_vm.change},on:{"close":function($event){return _vm.$router.push('/admin/finalrecon/list')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }